import { gql } from '@apollo/client';

export const DOCUMENT_STATES = gql`
  query documentStates {
    documentStates {
      id
      name
      code
    }
  }
`;

export const DOCUMENT_SIGN_STATE_TRANSITIONS = gql`
  query documentSignStateTransitions {
    documentSignStateTransitions {
      startStatus
      inProgressStatus
      endStatus
    }
  }
`;
